export const ProfileDataUrl = (): string => '/ClubLink/GetCustomerBaseInfo';

export const EditProfileUrl = (): string => '/ClubLink/EditCustomer';
